import { render, staticRenderFns } from "./UserPricing.vue?vue&type=template&id=9adfd59e&scoped=true&"
import script from "./UserPricing.vue?vue&type=script&lang=js&"
export * from "./UserPricing.vue?vue&type=script&lang=js&"
import style0 from "./UserPricing.vue?vue&type=style&index=0&id=9adfd59e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9adfd59e",
  null
  
)

export default component.exports